// extracted by mini-css-extract-plugin
module.exports = {"CircledArrowTop":"styles_CircledArrowTop__s0E3n"};